import { useEffect } from 'react';
import { Location as RouterLocation } from 'history';

import { unmountDocumentSection } from '../components/documents/my-documents/store';
import { unmountMyOpinionsTable } from '../components/opinions/my-opinions/store';
import { useAppDispatch } from './react-redux';

export const useTableUnMount = (previousLocation: RouterLocation<unknown>, currentLocation: RouterLocation<unknown>) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const prevPath = previousLocation.pathname;
        const currPath = currentLocation.pathname;
        const isRefresh = prevPath === currPath;

        const leavingMyDocuments = prevPath === '/documents/my-documents' && (!currPath.startsWith('/documents/analysis') && !['/documents/search', '/documents/my-documents/incomplete', '/documents/my-documents/pre-execution'].includes(currPath));
        const leavingPreExecutionDocuments = prevPath === '/documents/my-documents/pre-execution' && (!currPath.startsWith('/documents/analysis') && !['/documents/search', '/documents/my-documents/incomplete', '/documents/my-documents'].includes(currPath));
        const leavingMyDocumentsSubSections = (['/documents/analysis', '/documents/search', '/documents/my-documents/incomplete'].includes(prevPath)) && (!currPath.startsWith('/documents/analysis') && !['/documents/my-documents', '/documents/analysis', '/documents/search', '/documents/my-documents/incomplete', '/documents/my-documents/pre-execution'].includes(currPath)) ;

        if (!isRefresh && (leavingMyDocuments || leavingPreExecutionDocuments || leavingMyDocumentsSubSections)) {
            dispatch(unmountDocumentSection());
        }

        const leavingMyOpinions = prevPath === '/opinions/my-opinions/table' && (!currPath.startsWith('/opinions/analysis') &&!['/opinions/my-opinions/incomplete', '/opinions/my-opinions/map'].includes(currPath));
        const leavingMyOpinionsSubSections = (['/opinions/analysis', '/opinions/my-opinions/incomplete', '/opinions/my-opinions/map'].includes(prevPath)) && !['/opinions/my-opinions/table', '/opinions/analysis', '/opinions/my-opinions/incomplete', '/opinions/my-opinions/map'].includes(currPath);

        if (!isRefresh && (leavingMyOpinions || leavingMyOpinionsSubSections)) {
            dispatch(unmountMyOpinionsTable());
        }

    }, [previousLocation, currentLocation, dispatch]);
};
